// The worlds: which planets exist, and which heightfield answers for each.
// "One universe, many planets" becomes real the moment two rooms both say
// kind "surface" and mean different ground — this module is the dispatch
// point, so nothing else ever hardcodes "the" heightAt again.
//
// Ids are code-internal (they key plans, equipment rows and space anchors);
// player-facing names live on the plans' labels.

import { CITY_HALF, cityHeightAt } from "./city-terrain";
import { heightAt, PLANET_HALF } from "./terrain";

/**
 * The two worlds of the first star system: the frontier planet the game
 * began on, and Meridian — the port capital. The frontier keeps the id
 * "frontier" even though its surface room id is the historical "surface";
 * rooms and worlds are different axes (one world has many rooms on it).
 */
export const WORLD_IDS = ["frontier", "meridian"] as const;
export type WorldId = (typeof WORLD_IDS)[number];

/** Coerce a stored/replicated string; unknown reads "frontier". */
export function asWorldId(value: string | undefined): WorldId {
  return (WORLD_IDS as readonly string[]).includes(value ?? "") ? (value as WorldId) : "frontier";
}

/** The deterministic ground function for a world (IEEE-exact, shared). */
export function heightFieldFor(world: WorldId | undefined): (x: number, z: number) => number {
  return world === "meridian" ? cityHeightAt : heightAt;
}

/** Half-extent of a world's walkable ground box, metres. */
export function worldHalfFor(world: WorldId | undefined): number {
  return world === "meridian" ? CITY_HALF : PLANET_HALF;
}
